import styled from "styled-components";

type BadgeType = {
    background: string;
    color: string;
};

export const ButtonWrapper = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
`;

export const FilterCountBadge = styled.span<BadgeType>`
    position: absolute;
    top: -4px;
    right: -4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    background: ${(props) => props.background};
    color: ${(props) => props.color};
    pointer-events: none;
    z-index: 1;
`;
